
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { Sale } from "@/models/base";

export default Vue.extend({
	data() {
		return {
			autoSettleCreditNote: true,
			converting: false
		};
	},
	props: {
		sales: {
			type: Array as () => Sale[],
			required: true
		}
	},
	computed: {
		message(): TranslateResult {
			if (this.sales.length > 1) {
				return this.$ct("are-you-sure-you-want-to-convert-x-to-creditnote", {count: this.sales.length});
			}
			return this.$ct("are-you-sure-you-want-to-convert-invoice-to-creditnote", {invoice: this.sales[0].ComputedFriendlyID});
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		confirm() {
			if (this.converting) return;
			this.converting = true;
			this.$emit("confirm", this.autoSettleCreditNote);
		}
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
